import React, { useState, useEffect } from 'react';
// import { TreeView, TreeItem } from '@mui/lab';
import { Checkbox } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
import '../../../cssfiles/homepage.css';
import { Typography, Select, FormControl, InputLabel } from '@mui/material';



const AssetTagsRetrieval = ({ assetdata,setSelectedTag,setSelectedAsset }) => {
    //console.log("Refresh ")
    const theme = useSelector((state) => state.themedata.theme)

    const [checkedNode, setCheckedNode] = useState(null); // Holds the id of the currently checked node
    const [selectedCheckedNodeName, setSelectedCheckedNodeName] = useState(null); // Holds the name of the currently checked tree item
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate);
    const [pagesize, setPagesize] = useState(480);
    const [selectedtag, setSelectedtag] = useState("Test")
    { /*console.log("selectedCheckedNodeName////////////////",selectedCheckedNodeName) */}
    { /*console.log("checkedNode///////////////",checkedNode) */}

    useEffect(() => {
        if (overviewstate) {
            setPagesize(440);
        } else {
            setPagesize(380);
        }
      }, [overviewstate]);

    // Handle checkbox toggle
    const handleCheck = (node, nodeId, assetname,deviceId) => {
        setSelectedtag(assetname + "." +node["alias"])
        if (checkedNode === nodeId) {
            // If the clicked checkbox is already checked, uncheck it
            setCheckedNode(null);
            setSelectedCheckedNodeName(null);
            setSelectedTag( { tagname : '', tagunit : '', std_tagname: ''})
            setSelectedAsset({asset_name:'', device_id:''});
        } else {
            // If another checkbox is clicked, check it and update the state
            //console.log("SELECTED NODE",node)
            setSelectedTag( { tagname : node["alias"], tagunit : node["unit"], std_tagname: node["parameter_name"]})
            setSelectedAsset({asset_name:assetname, device_id:deviceId});
            setCheckedNode(nodeId);
            setSelectedCheckedNodeName(node["alias"]); // Assuming `alias` is the name of the tree item
        }
    };

    const handleonexpanditemchange = (e) => {
        e.stopPropagation()
    }

    const renderTreeNodes = (node, handleCheck, checkedNode, assetname, deviceId) => {
  
        if(node.hasOwnProperty("parameter_id") && node.hasOwnProperty("alias")){
            return (
                <TreeItem
                    key={deviceId + node["parameter_id"]}
                    itemId={deviceId + node["parameter_id"]}
                    label={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox style={{color:'var(--SecondaryText)'}}
                                checked={checkedNode === deviceId + node["parameter_id"]}
                                onChange={() => {
                                      //e.stopPropagation()
                                      
                                      //console.log("selected ",node, deviceId + node["key"],assetname,deviceId)
                                      handleCheck(node, deviceId + node["parameter_id"],assetname,deviceId)
                                  }
                                }
                                onClick = {(e) => e.stopPropagation()}
                            />
                            <span style={{color:'var(--SecondaryText)'}}>{node["alias"]}</span>
                        </div>
                    }
                >
                </TreeItem>
            );
        }else if(node.hasOwnProperty("key") && node.hasOwnProperty("alias")){
            return (
                <TreeItem
                    key={deviceId + node["key"]}
                    itemId={deviceId + node["key"]}
                    label={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox style={{color:'var(--SecondaryText)'}}
                                checked={checkedNode === deviceId + node["key"]}
                                onChange={() => {
                                      //e.stopPropagation()
                                      
                                      //console.log("selected ",node, deviceId + node["key"],assetname,deviceId)
                                      handleCheck(node, deviceId + node["key"],assetname,deviceId)
                                  }
                                }
                                onClick = {(e) => e.stopPropagation()}
                            />
                            <span style={{color:'var(--SecondaryText)'}}>{node["alias"]}</span>
                        </div>
                    }
                >
                </TreeItem>
            );
        }
       
      };

  return (
    <div style={{ width: "310px", marginRight: "0px"}}>
        <FormControl variant="filled" sx={{ minWidth: 120, width: '300px', marginBottom: '20px', padding: '0px'}}>
            <InputLabel style={{color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C', fontSize: 18, fontWeight: 400}}> Data Point </InputLabel>
            <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selectedtag}
                //onChange={handlechangefonttype}
                //input={<InputLabel sx={{fontSize: '2rem'}} label="Tag" />}
                label= {<Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Data Point </Typography> }
                
                sx={{
                    border: 0,
                    width: '300px',
                    bgcolor: 'transparent',
                    color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C',
                    fontSize: "18px",
                    fontFamily: 'Roboto',
                    fontWeight: 400,
                    textAlign: 'left',
                    borderRadius: 0,
                    marginRight: '0px',
                    p: 0,
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                        borderColor: "red"
                        },
                        "&:hover fieldset": {
                        borderColor: "yellow"
                        },
                        "& .Mui-focused fieldset": {
                        borderColor: "green"
                        }
                    },
                    '& .MuiOutlinedInput-input': {p: 0},
                    '& .MuiOutlinedInput-underline': {borderBottom: '2px soild'},
                    '& .MuiOutlinedInput-underline:before': { borderBottomColor: theme === 'dark' ? '#FFFFFF' : '#3C3C3C' },
                    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: 0,
                        fontSize: 25 
                    },
                    '& .MuiInputLabel-root': { display: 'none', legend: 'none', fontSize: "14px"  },
                    '& .MuiSelect-select': {
                        paddingTop: "25px",
                        paddingBottom: "0px"
                    }
                }}
                
                MenuProps={{
                    disablePortal: false, // <--- HERE
                    onClick: e => {
                        e.preventDefault();
                    },
                    PaperProps: {
                        sx: {
                            bgcolor: theme === 'dark' ? '#3C3C3C' : '#C1C1C1',
                            borderBottom: '2px solid #008CD7',
                            borderRadius: 0,
                            boxShadow: 'none',
                            maxHeight: '250px',
                            overflow: 'auto',
                            color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C',
                        }
                    },

                }}
            >
                <Box style={{ /*border: "1px solid #008CD7",*/ display: 'flex', flexDirection: 'column', height: "100%", padding: '0px 16px', overflowY: "scroll" }}>
                    {assetdata !== null ? (
                        assetdata.hasOwnProperty("data") && assetdata["data"].hasOwnProperty("grouplist") ? (
                            assetdata["data"]["grouplist"].map((objecttreeview, index) => {
                                if (objecttreeview.hasOwnProperty("assetName") && objecttreeview.hasOwnProperty("parameters") && Array.isArray(objecttreeview["parameters"])) {
                                    return (
                                        <div style={{ display: "block" }} key={index}>
                                            <SimpleTreeView sx={{color:'var(--SecondaryText)'}} defaultCollapseIcon="-" defaultExpandIcon="+" onExpandedItemsChange={handleonexpanditemchange}>
                                                <TreeItem itemId={objecttreeview["deviceId"]} label={objecttreeview["assetName"]}>
                                                    {objecttreeview["parameters"].map((tagGroup, index) =>
                                                        renderTreeNodes(tagGroup, handleCheck, checkedNode,objecttreeview["assetName"],objecttreeview["deviceId"])
                                                    )}
                                                </TreeItem>
                                            </SimpleTreeView>
                                        </div>
                                    );
                                } else {
                                    return <></>;
                                }
                            })
                        ) : <></>
                    ) : <></>}
                </Box>
            </Select> 
        </FormControl>
            
    </div>
  );
};

export default AssetTagsRetrieval;

